
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";

// const ApiProvider = (instance, account) => {
export default class ApiProvider{
    constructor(instance, account){
        this._instance = instance;
        this._account = account;
    }

    async Put(path, params, contentType, isFile){
        return this.callAPI(path, 'PUT', params, contentType, isFile);
    }

    // _instance = instance;
    // _account = account;

    async Get(path, params, contentType, isFile){
        return this.callAPI(path, 'GET', params, contentType, isFile)
    };
    async Post(path, params, contentType, isFile){
        return this.callAPI(path, 'POST', params, contentType, isFile); 
    };
    async Patch(path, params, contentType, isFile){
        return this.callAPI(path, 'PATCH', params, contentType, isFile);
    };
    async Delete(path, params, contentType, isFile){
        return this.callAPI(path, 'DELETE', params, contentType, isFile);
    };
    async callAPI(path, verb, params, contentType, isFile){ 
        if(!window.env){
            await fetch('/settings.json',{
                headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                }
            })
            .then(response =>  {
                return response.json();
                })
            .then((data) => window.env = data )
            .catch(error => console.error(error));
        }


        const request = {
            scopes: [window.env.apiScope],
            account: this._account
        }
        var token;
        try {
            token =  (await this._instance.acquireTokenSilent(request)).accessToken;
        } catch {
            token = (await this._instance.acquireTokenPopup(request)).accessToken;
        }
        if(!window.language){
            window.language = 'en';
        }
        if(!contentType){
            contentType = "application/json";
            params = params ? JSON.stringify(params) : null
        }

        const headers = new Headers();
        const bearer = `Bearer ${token}`;

        headers.append("Authorization", bearer);
        headers.append("Accept","*/*");
        if(contentType !== "multipart/form-data")
            headers.append("Content-Type", contentType);
        headers.append("Content-Language", window.language);

        const options = {
            method: verb,
            headers: headers,
            body: params
        };

        const response = await fetch(`${window.env.baseUrl}/${path}`, options).catch(error => {console.log(error); return error;});
        if (response.ok) {
            const contentType = response.headers.get('content-type');
            if (isFile === true)
                return await response.blob();
            if (contentType && contentType.indexOf('application/json') !== -1) {
                return await response.json();
            } else if(contentType && contentType.indexOf('text/plain') !== -1) {
                return await response.text();
            } else if(contentType && contentType.indexOf('application/pdf') !== -1) {
                return await response.text();
            }
            return "";
        } else if(response.ok === false){
            let customMessage = "";
            switch(response.status){
                case 404:
                    customMessage = `404 Unable to find endpoint. ${window.env.baseUrl}/${path}`;
                    break;
                case 500:
                    customMessage = (await response.json()).error;
                    break;
                default:
                    customMessage = "Something went wrong";
                    break;

            }
            alert(customMessage);
            const responseError = {
                type: 'Error',
                message: response.message || customMessage,
                data: response.data || '',
                code: response.status || '',
            };   
            let error = new Error();
            error = { ...error, ...responseError };
            return {error: error};
        } else{
            return {error: response};
        }
    }
}